var _excluded = ["onKeyDown"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { useCombobox } from "downshift";
import moment from "moment";
import { isEmpty } from "lodash-es";
import Input from "../../forms/input/Input";
import { TIME_FORMAT } from "./constants";
import { onEnter } from "../../helpers";
import { inferTime, toMinutes } from "./parseDate";
import { getHoursAndMinutes } from "./utils";
function format(num) {
  var day = moment();
  day.set(getHoursAndMinutes(num));
  return day.format(TIME_FORMAT);
}
var options = [];
var formats = [];
var MINUTES_IN_DAY = 60 * 24;
for (var i = 0; i < MINUTES_IN_DAY; i += 30) {
  options.push(i);
  formats[i] = format(i);
}
function closestIndex(num) {
  var prev = options[0];
  for (var _i = 1; _i < options.length; _i++) {
    var curr = options[_i];
    if (Math.abs(num - curr) > Math.abs(num - prev)) {
      return _i - 1;
    }
    prev = curr;
  }
  return options.length - 1;
}
function formatValue(value) {
  if (typeof value === "number" && formats[value]) {
    return formats[value];
  }
  if (typeof value === "string" && isEmpty(value)) {
    return value;
  }
  return format(value);
}
export function TimeSelect(props) {
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var inputRef = useRef();
  var optionsRef = useRef();
  useEffect(function () {
    setInputValue(formatValue(props.value));
  }, [props.value]);
  var _useCombobox = useCombobox({
      items: options,
      selectedItem: props.value,
      onSelectedItemChange: function onSelectedItemChange(_ref) {
        var selectedItem = _ref.selectedItem;
        props.onChange(selectedItem);
      },
      itemToString: formatValue
    }),
    isOpen = _useCombobox.isOpen,
    getLabelProps = _useCombobox.getLabelProps,
    getMenuProps = _useCombobox.getMenuProps,
    getItemProps = _useCombobox.getItemProps,
    getInputProps = _useCombobox.getInputProps,
    openMenu = _useCombobox.openMenu,
    setHighlightedIndex = _useCombobox.setHighlightedIndex;
  useLayoutEffect(function scrollOptionIntoView() {
    var minutes = toMinutes(inferTime(inputValue, props.date));
    var index = options.findIndex(function (option) {
      return minutes === option;
    });
    if (index !== -1) setHighlightedIndex(index);else if (isOpen) {
      var closest = closestIndex(minutes);
      requestAnimationFrame(function () {
        var option = optionsRef.current.querySelector("li:nth-child(".concat(closest + 1, ")"));
        if (option) {
          option.scrollIntoView({
            block: "center"
          });
        }
      });
    }
  }, [inputValue, isOpen]);
  var _getInputProps = getInputProps({
      ref: inputRef,
      onFocus: function onFocus(e) {
        if (!isOpen) openMenu();
        var input = e.currentTarget.querySelector("input");
        input.setSelectionRange(0, input.value.length);
      },
      onBlur: function onBlur() {
        if (isEmpty(inputValue)) {
          props.onChange(inputValue);
          return;
        }
        var value = toMinutes(inferTime(inputValue, props.date));
        if (value === props.value) setInputValue(formatValue(props.value));else props.onChange(value);
      },
      onChange: function onChange(e) {
        setInputValue(e.currentTarget.value);
      },
      onKeyDown: onEnter(function () {
        var value = toMinutes(inferTime(inputValue, props.date));
        if (value === props.value) setInputValue(formatValue(props.value));else props.onChange(value);
      })
    }),
    onKeyDown = _getInputProps.onKeyDown,
    inputProps = _objectWithoutProperties(_getInputProps, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "tui-date-picker__time-select"
  }, /*#__PURE__*/React.createElement("label", _extends({}, getLabelProps(), {
    style: {
      display: "none"
    }
  }), "Time"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, _extends({
    disabled: props.disabled
  }, inputProps, {
    inputProps: {
      autoComplete: "off",
      onKeyDown: onKeyDown
    },
    value: inputValue
  }))), /*#__PURE__*/React.createElement("ul", _extends({
    className: "tui-date-picker__time-select__options",
    style: {
      display: isOpen ? undefined : "none"
    }
  }, getMenuProps({
    ref: optionsRef
  }), {
    tabIndex: -1
  }), isOpen && options.map(function (item, index) {
    var disabled = props.minTime && Number(props === null || props === void 0 ? void 0 : props.minTime) > Number(item);
    return /*#__PURE__*/React.createElement("li", _extends({
      key: "".concat(item).concat(index)
    }, getItemProps({
      item: item,
      index: index,
      disabled: disabled,
      className: disabled ? "disabled" : ""
    })), formats[item]);
  })));
}
//# sourceMappingURL=TimeSelect.js.map